import angular from "angular";

/**
 * angular-timezone-selector
 *
 * Started with this: https://github.com/mishguruorg/angular-timezone-selector
 *
 * A simple directive that allows a user to pick their timezone
 *
 * Author:  Ashok Fernandez <ashok@mish.guru>
 * Date:    12/06/2015
 * License: MIT
 */

// time-zone-picker
angular
    .module('ui-common')
    .directive('timeZonePicker', ['TimeZonesByGroup', function (TimeZonesByGroup) {
        return {
            require: '?ngModel',
            restrict: 'E',
            replace: true,
            template: '<select style="min-width:225px;"></select>',
            scope: {
                ngModel: '=',
                translations: '='
            },
            link: function ($scope, elem, attrs) {
                const jqElem = $(elem);

                // lets the "allow_single_deselect" option to work
                jqElem.append($(`<option value=""></option>`));

                for (const group of TimeZonesByGroup) {
                    const optgroup = $(`<optgroup label="${group.text}">`)
                    for (const option of group.children) {
                        optgroup.append(`<option value="${option.id}">${option.label}</option>`)
                    }
                    jqElem.append(optgroup)
                }

                // Initialize the chosen box
                jqElem.chosen({
                    width: attrs.width || '225px',
                    include_group_label_in_selected: false,
                    search_contains: true,
                    allow_single_deselect: true,
                    no_results_text: 'No results, try searching for the name of your country or nearest major city.',
                    placeholder_text_single: 'Choose a timezone'
                }).change(() => {
                    $scope.ngModel = jqElem.val();
                    $scope.$apply();
                });

                // Update the box if ngModel changes
                $scope.$watch('ngModel', function () {
                    jqElem.val($scope.ngModel)
                    jqElem.trigger('chosen:updated')
                })
            }
        }
    }]);
